module.exports = __webpack_public_path__ + "static/media/successfulTaxDataLogo.8ed8751e.svg";